import { render, staticRenderFns } from "./FileImportCompany.vue?vue&type=template&id=dc7536aa&scoped=true&"
import script from "./FileImportCompany.vue?vue&type=script&lang=js&"
export * from "./FileImportCompany.vue?vue&type=script&lang=js&"
import style0 from "./FileImportCompany.vue?vue&type=style&index=0&id=dc7536aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7536aa",
  null
  
)

export default component.exports